import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import MerchantDomainBase, {
  SupportedCountry,
} from "entities/domain/admin/merchants/merchant-domain";
import ChannelDomain from "entities/domain/contacts/contact-domain";
import { getUTCOffsetByCountryCode } from "util/methods";

interface MerchantState {
  isInitialLoading: boolean;
  loading: boolean;
  errors: any[];
  merchantId: number | null; // Keep only ID for backward compatibility with hooks that need it
  isSelectorOpened: boolean;
  timeZoneOffset: number;
}
const initialState: MerchantState = {
  merchantId: null,
  isInitialLoading: false,
  loading: false,
  errors: [],
  isSelectorOpened: false,
  timeZoneOffset: 0, // UTC
};

const merchantSlice = createSlice({
  name: "merchant",
  initialState,
  reducers: {
    fetchMerchant: (state) => {
      state.isInitialLoading = true;
      state.loading = true;
    },
    fetchMerchantSuccess: (
      state,
      action: PayloadAction<MerchantDomainBase>
    ) => {
      state.merchantId = action.payload.id;
      state.timeZoneOffset = getUTCOffsetByCountryCode(action.payload.country);
      state.isInitialLoading = false;
      state.loading = false;
      state.errors = [];
    },
    setIsSelectorOpened: (state, action: PayloadAction<boolean>) => {
      state.isSelectorOpened = action.payload;
    },
    setMerchantId: (
      state,
      action: PayloadAction<{ id: number; country: SupportedCountry }>
    ) => {
      state.merchantId = action.payload.id;
      state.timeZoneOffset = getUTCOffsetByCountryCode(action.payload.country);
      state.isInitialLoading = false;
      state.loading = false;
    },
    fetchMerchantFail: (state, action: PayloadAction<string[]>) => {
      state.errors = action.payload;
      state.isInitialLoading = false;
      state.loading = false;
    },
    updateMerchant: (state) => {
      state.loading = true;
    },
    updateMerchantSuccess: (
      state,
      action: PayloadAction<MerchantDomainBase>
    ) => {
      state.merchantId = action.payload.id;
      state.timeZoneOffset = getUTCOffsetByCountryCode(action.payload.country);
      state.loading = false;
      state.errors = [];
    },
    updateMerchantFail: (state, action: PayloadAction<string[]>) => {
      state.errors = action.payload;
      state.loading = false;
    },
    fetchMerchantUsageFail: (state, action: PayloadAction<string[]>) => {
      state.errors = action.payload;
    },
    resetStore: (state) => {
      // do not reset merchantId itself
      state.isSelectorOpened = false;
      state.loading = false;
      state.errors = [];
      state.timeZoneOffset = 0;
      state.isInitialLoading = false;
    },
  },
});

export const {
  fetchMerchant,
  fetchMerchantSuccess,
  fetchMerchantFail,
  updateMerchant,
  updateMerchantSuccess,
  updateMerchantFail,
  setIsSelectorOpened,
  setMerchantId,
  fetchMerchantUsageFail,
  resetStore,
} = merchantSlice.actions;
export const merchantSliceActions = merchantSlice.actions;
export default merchantSlice.reducer;
